import React from 'react'
import { useTranslation } from 'react-i18next'
import { OrderStatus } from '@/types'

export type StatusFilter = 'all' | OrderStatus

interface StatusFilterButtonsProps {
  selectedStatus: StatusFilter
  onStatusChange: (status: StatusFilter) => void
  isRTL?: boolean
}

const StatusFilterButtons: React.FC<StatusFilterButtonsProps> = ({
  selectedStatus,
  onStatusChange,
  isRTL = false,
}) => {
  const { t } = useTranslation()

  const statuses: Array<{ value: StatusFilter; label: string }> = [
    { value: 'all', label: t('orders.filter.all_statuses') },

 { value: 'completed', label: t('orders.status.completed') },
    { value: 'preparing', label: t('orders.status.preparing') },

    { value: 'pending', label: t('orders.status.pending') },
   
  ]

  return (
    <div className={`flex items-center gap-3 ${isRTL ? 'flex-row-reverse' : ''}`}>
      {statuses.map((status) => {
        const isActive = selectedStatus === status.value
        return (
          <button
            key={status.value}
            onClick={() => onStatusChange(status.value)}
            className={`
              h-10 px-4 py-1 rounded-xl flex items-center gap-2 transition-all
              ${isActive 
                ? 'bg-flutter-button shadow-[inset_0px_0px_0px_1px_rgba(0,0,0,0.25)]' 
                : 'bg-white'
              }
              ${isRTL ? 'flex-row-reverse' : ''}
            `}
          >
            <span
              className={`
                text-sm font-medium font-['IBM Plex Sans Arabic']
                ${isActive ? 'text-text-primary-on-accent' : 'text-text-primary'}
                ${isRTL ? 'text-right' : 'text-left'}
              `}
            >
              {status.label}
            </span>
          </button>
        )
      })}
    </div>
  )
}

export default StatusFilterButtons

